import { GzCountDownWebComponent } from './component/GzCountDownWebComponent';
import { WEB_COMPONENT_GZ_COUNT_DOWN } from '../../webcomponents.constants';

export { GzCountDownWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_COUNT_DOWN, GzCountDownWebComponent);

export enum GzCountDownEvents {
  TIMER_HAS_STARTED = 'timerHasStarted',
  TIMER_HAS_STOPPED = 'timerHasStopped',
  TIMER_MILESTONE_REACHED = 'timerMilestoneReached',
}
